import script from "./PointsRecharge.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsRecharge.vue?vue&type=script&setup=true&lang=js"

import "./PointsRecharge.vue?vue&type=style&index=0&id=14e1bd16&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14e1bd16"]])

export default __exports__